export default {
  // Common
  common: {
    loading: 'Завантаження...',
    loadingData: 'Завантаження даних...',
    save: 'Зберегти',
    cancel: 'Скасувати',
    delete: 'Видалити',
    edit: 'Редагувати',
    close: 'Закрити',
    confirm: 'Підтвердити',
    back: 'Назад',
    next: 'Далі',
    previous: 'Попередній',
    search: 'Пошук',
    filter: 'Фільтр',
    clearFilters: 'Очистити фільтри',
    clear: 'Очистити',
    all: 'Всі',
    none: 'Немає',
    yes: 'Так',
    no: 'Ні',
    actions: 'Дії',
    details: 'Деталі',
    download: 'Завантажити',
    downloadPDF: 'Завантажити PDF',
    viewDetails: 'Переглянути деталі',
    noData: 'Немає даних',
    error: 'Помилка',
    success: 'Успіх',
    warning: 'Попередження',
    info: 'Інформація',
    date: 'Дата'
  },

  // DataTable common
  dataTable: {
    sortBy: 'Сортувати за',
    sortAsc: 'За зростанням',
    sortDesc: 'За спаданням',
    filters: 'Фільтри',
    applyFilters: 'Застосувати фільтри',
    clearFilters: 'Очистити фільтри'
  },

  // Navigation
  nav: {
    home: 'Головна',
    invoices: 'Рахунки',
    issues: 'Заявки',
    generation: 'Генерація',
    data: 'Дані',
    customers: 'Клієнти',
    contracts: 'Договори',
    consumptionPoints: 'Точки споживання',
    myAccount: 'Мій акаунт',
    profile: 'Профіль',
    linkAccount: 'Прив\'язати акаунт',
    logout: 'Вийти',
    backToSite: 'Назад',
    operatorManagement: 'Управління операторами',
    impersonate: 'Імперсонація',
    menu: 'Меню',
    openMenu: 'Відкрити меню',
    closeMenu: 'Закрити меню',
    help: 'Інструкція користувача'
  },

  // Footer
  footer: {
    help: 'Інструкція користувача',
    terms: 'Регламент EPK',
    privacy: 'Політика конфіденційності',
    support: 'Проблема з порталом',
    supportSubject: 'Портал EPK — технічна проблема',
    securedBy: 'Безпечні платежі забезпечує',
    autopayAlt: 'Autopay'
  },

  // Help / User manual
  help: {
    tocLabel: 'Зміст',
    translationPending: 'Переклад готується — показано польську версію.',
    sectionNotFound: 'Розділ не знайдено.',
    backToHome: 'Повернутися до панелі',
    backToFirstSection: 'Повернутись до першого розділу',
    loadFailed: 'Не вдалося завантажити інструкцію.'
  },

  // Auth
  auth: {
    login: 'Увійти',
    logout: 'Вийти',
    register: {
      subtitle: 'Зареєструйтесь для доступу до енергетичного порталу.',
      firstNamePlaceholder: 'Іван',
      lastNamePlaceholder: 'Іваненко',
      phonePlaceholder: '+48 000 000 000',
      phoneHint: '+48 вписаний за замовчуванням — ви можете змінити його, якщо номер з-поза Польщі. Формат: +<код країни><цифри>',
      phoneFormatError: 'Номер має починатися з „+" та коду країни (напр. +48 для Польщі).',
      passwordMinLength: 'Мінімум 8 символів',
      passwordMinLengthError: 'Пароль повинен містити щонайменше 8 символів',
      passwordMismatch: 'Паролі не збігаються',
      submitButton: 'Зареєструватися',
      submitting: 'Створення облікового запису...',
      failed: 'Реєстрація не вдалася. Спробуйте ще раз.',
      alreadyHaveAccount: 'Вже маєте обліковий запис? Увійдіть'
    },
    email: 'Електронна пошта',
    password: 'Пароль',
    confirmPassword: 'Підтвердіть пароль',
    firstName: 'Ім\'я',
    lastName: 'Прізвище',
    phone: 'Телефон',
    forgotPassword: 'Забули пароль?',
    noAccount: 'Немає акаунту? Зареєструйтесь тут',
    hasAccount: 'Вже маєте акаунт? Увійдіть',
    loggingIn: 'Вхід...',
    registering: 'Реєстрація...',
    loginFailed: 'Помилка входу. Спробуйте ще раз.',
    tooManyAttempts: 'Забагато спроб входу. Спробуйте ще раз через {minutes} хв.',
    registerSuccess: 'Реєстрація успішна. Перевірте електронну пошту для підтвердження.',
    welcomeBack: 'З поверненням! Увійдіть до свого акаунту.',
    createAccount: 'Створіть свій акаунт в Електронному Порталі Клієнта',
    passwordReset: 'Скидання пароля',
    passwordResetRequest: 'Запит на скидання пароля',
    passwordResetConfirm: 'Підтвердіть новий пароль',
    resetPassword: 'Скинути пароль',
    enterEmail: 'Введіть вашу електронну адресу',
    enterNewPassword: 'Введіть новий пароль',
    passwordResetSent: 'Посилання для скидання пароля надіслано на вашу електронну пошту.',
    passwordResetSuccess: 'Пароль змінено. Тепер ви можете увійти.',
    invalidResetToken: 'Недійсний або прострочений токен скидання пароля.',
    tooManyAttempts: 'Забагато спроб входу. Спробуйте ще раз через {minutes} хв.',
    verifyEmail: {
      title: 'Верифікація електронної пошти',
      verifying: 'Верифікація...',
      success: 'Вашу електронну адресу успішно верифіковано.',
      alreadyVerified: 'Цю електронну адресу вже верифіковано.',
      error: 'Недійсний або прострочений токен верифікації.',
      noToken: 'У посиланні відсутній токен верифікації.',
      goToLogin: 'Перейти до входу'
    },
    resendVerification: {
      description: 'Введіть адресу електронної пошти для повторної відправки посилання активації.',
      submit: 'Надіслати',
      success: 'Посилання активації надіслано на вказану адресу.'
    },
    emailNotVerified: 'Адресу електронної пошти не верифіковано. Перевірте вашу скриньку.',
    resendButton: 'Повторно надіслати посилання активації',
    alreadyVerified: 'Адресу вже верифіковано. Якщо забули пароль, скористайтесь скиданням пароля.',
    resetPasswordLink: 'Скинути пароль'
  },

  // Dashboard
  dashboard: {
    welcome: 'Вітаємо, {name}!',
    welcomeDefault: 'Вітаємо, Користувач!',
    subtitle: 'Огляд вашого енергетичного акаунту',
    currentBalance: 'Поточний баланс',
    activeContracts: 'Активні договори',
    expiringContracts: '{count} закінчуються незабаром',
    allContractsCurrent: 'Всі договори актуальні',
    monthlyConsumption: 'Споживання за поточний місяць',
    consumptionChange: '{percent}% {direction} ніж минулого місяця',
    consumptionMore: 'більше',
    consumptionLess: 'менше',
    noConsumptionData: 'Немає даних за попередній місяць',
    consumptionBreakdownTitle: 'Споживання цього місяця за ТКО',
    breakdownPpeCode: 'Код ТКО',
    breakdownCustomer: 'Клієнт',
    breakdownConsumption: 'Споживання',
    breakdownChange: '% м/м',
    openInvoices: 'Відкриті рахунки',
    overdueInvoices: '{count} прострочених',
    noOverdueInvoices: 'Немає прострочених рахунків',
    balanceOutsideSelfService: 'Частина балансу стосується документів, недоступних у порталі — зверніться до нас',
    newIssue: 'Нова заявка',
    linkCustomerAccount: 'Прив\'язати акаунт клієнта',
    reportIssue: 'Подати заявку',
    recentInvoices: 'Останні рахунки',
    recentContracts: 'Останні договори',
    recentIssues: 'Останні активні заявки',
    activeTasks: 'Активні завдання',
    viewAll: 'Переглянути всі',
    noActiveIssues: 'Немає активних заявок',
    allMattersResolved: 'Всі справи вирішено',
    loadFailed: 'Не вдалося завантажити дані панелі'
  },

  // Invoices
  invoices: {
    title: 'Рахунки',
    subtitle: 'Перегляд та управління вашими рахунками',
    invoiceNumber: 'Номер рахунку',
    customer: 'Клієнт',
    issueDate: 'Дата виставлення',
    amount: 'Сума',
    overpaymentTooltip: 'Сума переплати',
    paymentDeadline: 'Термін оплати',
    status: 'Статус',
    period: 'Період',
    consumption: 'Споживання',
    dateRange: 'Діапазон дат',
    searchPlaceholder: 'Номер рахунку...',
    allCustomers: 'Всі клієнти',
    customerOptionNip: '{name} (ІПН {nip})',
    customerOptionNumber: '{name} (№ клієнта {number})',
    allStatuses: 'Всі',
    noInvoices: 'Немає рахунків',
    loadFailed: 'Не вдалося завантажити рахунки',
    downloadSuccess: 'Рахунок успішно завантажено',
    downloadFailed: 'Не вдалося завантажити PDF рахунку',
    showingResults: 'Показано {first} до {last} з {total} рахунків',
    statuses: {
      paid: 'Оплачено',
      pending: 'Очікує',
      unpaid: 'Не оплачено',
      overdue: 'Прострочено',
      partiallyPaid: 'Частково оплачено',
      cancelled: 'Скасовано'
    },
    paymentMethod: {
      transfer: 'Банківський переказ',
      compensation: 'Компенсація',
      payment: 'Платіж'
    },
    lineItems: {
      title: 'Позиції',
      description: 'Опис',
      quantity: 'Кількість',
      unitPrice: 'Ціна за од.',
      value: 'Вартість',
      empty: 'Немає позицій'
    },
    detail: {
      loadFailed: 'Не вдалося завантажити деталі рахунку',
      title: 'Деталі рахунку',
      issuedOn: 'Виставлено: {date}',
      billingPeriod: 'Розрахунковий період',
      paymentHistory: 'Історія платежів',
      summary: 'Підсумок',
      netAmount: 'Сума без ПДВ',
      vat: 'ПДВ ({rate}%)',
      totalDue: 'Разом до сплати',
      paidAmount: 'Сплачено',
      remainingAmount: 'Залишок до сплати',
      settledAmount: 'Зараховано',
      outstandingAmount: 'Залишок до зарахування',
      taxId: 'ІПН',
      contract: 'Договір'
    }
  },

  // Contracts
  contracts: {
    title: 'Договори',
    subtitle: 'Перегляд та управління вашими енергетичними договорами',
    contractNumber: 'Номер договору',
    customer: 'Клієнт',
    dateFrom: 'Дата початку',
    dateTo: 'Дата закінчення',
    status: 'Статус',
    searchPlaceholder: 'Номер договору...',
    allCustomers: 'Всі клієнти',
    allStatuses: 'Всі',
    noContracts: 'Немає договорів',
    loadFailed: 'Не вдалося завантажити договори',
    daysUntilExpiration: '{days} днів до закінчення',
    statuses: {
      active: 'Активний',
      expiring: 'Закінчується',
      expired: 'Закінчився',
      pending: 'Очікує',
      cancelled: 'Скасований'
    },
    detail: {
      consumptionPoints: 'Точки споживання',
      address: 'Адреса',
      tariffGroup: 'Тарифна група',
      contractedPower: 'Договірна потужність'
    }
  },

  // Issues
  issues: {
    schedule: {
      before: 'Графік — до виправлення',
      after: 'Графік — після виправлення',
      beforeDate: 'Дата помилкової зміни',
      afterDate: 'Дата правильної зміни',
      selectPpeAndDate: 'Виберіть PPE та дату, щоб завантажити графік.',
    },
    title: 'Мої заявки',
    subtitle: 'Історія та статус ваших заявок',
    newIssue: 'Нова заявка',
    createFirst: 'Створіть першу заявку',
    noIssues: 'Немає заявок',
    noIssuesDescription: 'У вас ще немає заявок',
    searchPlaceholder: 'Пошук заявок...',
    allStatuses: 'Всі',
    allCustomers: 'Всі клієнти',
    daysUntilDeadline: '{days} днів до терміну',
    addReply: 'Додати відповідь',
    replyPlaceholder: 'Напишіть відповідь...',
    loadFailed: 'Не вдалося завантажити заявки',
    reopenedToast: 'Відповідь додано. Звернення повторно відкрито.',
    commentAddedToast: 'Коментар додано',
    commentFailedToast: 'Не вдалося додати коментар',
    finishedBanner: {
      title: 'Звернення завершено',
      deadlineHint: 'Ви можете додати коментар ще протягом {deadline}. Після цього звернення буде закрито остаточно.',
      reopenHint: 'Додавання коментаря призведе до повторного відкриття звернення.'
    },
    canceledBanner: {
      title: 'Ви скасували це звернення',
      deadlineHint: 'Ви можете додати коментар ще протягом {deadline}. Після цього звернення буде закрито остаточно.',
      reopenHint: 'Додавання коментаря призведе до повторного відкриття звернення.'
    },
    cancel: {
      button: 'Скасувати звернення',
      dialogTitle: 'Скасування звернення',
      dialogQuestion: 'Ви впевнені, що хочете скасувати це звернення?',
      dialogHint: 'Після скасування ви зможете додавати коментарі ще протягом 3 днів. Ви також можете створити нове звернення в будь-який час.',
      dialogCancel: 'Ні, повернутися',
      dialogConfirm: 'Так, скасувати звернення',
      toastSuccess: 'Звернення скасовано',
      toastError: 'Не вдалося скасувати звернення'
    },
    statuses: {
      new: 'Нова',
      inProgress: 'В роботі',
      reopened: 'Знову відкрите',
      waiting: 'Очікує на клієнта',
      waitingThirdParty: 'Очікує на відповідь дистриб\u0027ютора',
      completed: 'Завершено',
      canceled: 'Скасовано',
      archived: 'В архіві',
      deferred: 'Відкладено'
    },
    fields: {
      document_number: 'Номер документа',
      ppe_number: 'Номер PPE',
      new_reading_cycle: 'Новий цикл зчитування',
      target_tariff: 'Цільовий тариф',
      reported_to_osd: 'Чи було повідомлено про зміну в OSD?',
      report_to_osd: 'Повідомити про зміну в OSD від імені Клієнта?',
      effective_date_type: 'Дата набуття чинності змін',
      first_available_date: 'Перший можливий термін',
      other_date: 'Інша дата',
      current_power: 'Поточна договірна потужність',
      target_power: 'Цільова договірна потужність',
      connection_power_change: 'Чи змінюється потужність підключення?',
      connection_power_warning: 'Зміна потужності підключення може бути здійснена Клієнтом безпосередньо в OSD.',
      block_connection_power_change: 'Зміна потужності підключення може бути здійснена Клієнтом безпосередньо в OSD.',
      is_new_connection: 'Чи є новий PPE новим підключенням?',
      osd: 'Який OSD?',
      current_seller: 'Хто є поточним продавцем?',
      termination_period: 'Який термін розірвання?',
      assignee_data: 'Дані цесіонарія',
      assignment_start_date: 'Дата початку цесії',
      contract_number: 'Номер договору',
      extension_period: 'Період продовження',
      installation_power: 'Потужність установки',
      energy_type: 'Тип енергії',
      energy_type_full: 'Повністю',
      energy_type_surplus: 'Надлишок',
      ppe_numbers: 'Номери PPE',
      period_start: 'Період з',
      period_end: 'Період до',
      new_contact: 'Новий номер телефону / email',
      keep_old_contact: 'Залишити попередній контакт?',
      invoice_numbers: 'Номери рахунків',
      meter_reading: 'Показання лічильника',
      not_nots_number: 'Номер NOT/NOTS',
      summons_number: 'Номер вимоги',
      summons_date: 'Дата вимоги',
      compensation_number: 'Номер компенсації / заяви',
      penalty_number: 'Номер штрафу за договором',
      additional_info: 'Опис',
      opis_zgloszenia: 'Опис заявки',
      searchPlaceholder: 'Пошук...',
      yes: 'Так',
      no: 'Ні',
      assignee_name: 'Назва цесіонарія',
      assignee_nip: 'ІПН цесіонарія',
      assignee_address: 'Основна адреса',
      assignee_correspondence_address: 'Адреса для кореспонденції',
      assignee_contact: 'Контактні дані',
      bank_name: 'Назва банку',
      bank_account: 'Номер банківського рахунку',
      annual_surplus_volume_mwh: 'Прогнозований річний обсяг надлишку',
      keep_previous_contact: 'Чи залишити попередній номер телефону/email для контакту?',
      selectAll: 'Всі',
      loadingOptions: 'Завантаження опцій...',
      requiredField: 'Це поле є обов\'язковим',
      osdAutoFillPlaceholder: 'OSD буде встановлено після вибору ППЕ',
      osdAutoFillLoading: 'Зчитування OSD з ППЕ...',
      osdAutoFillErrorSummary: 'Помилка OSD',
      osdAutoFillError: 'Не вдалося зчитати OSD — зверніться до підтримки.',
      osdAutoFillPpeNotFound: 'ППЕ з таким номером не знайдено. Перевірте значення.',
      osdAutoFillMissing: 'Вкажіть номер ППЕ, щоб система автоматично заповнила поле OSD. Без OSD неможливо надіслати запит.',
      osdAutoFillFailedPlaceholder: 'Виберіть OSD вручну'
    },
    info: {
      overpayment_scan: 'Будь ласка, додайте заяву про повернення переплати у вигляді скану.',
      correction_note_scan: 'Будь ласка, додайте коригувальну ноту у вигляді скану.',
      termination_signature: 'Будь ласка, додайте розірвання: електронно з кваліфікованим підписом або оригінал до офісу компанії — інакше розірвання буде недійсним.',
      assignment_osd_process: 'Після повідомлення про зміну власника в OSD починається процес верифікації (21 день–1,5 місяця). Оператор визначить дату, з якої рахунки будуть виставлятися новому одержувачу.',
      new_connection_docs: 'Будь ласка, додайте акт власності та документи, необхідні OSD.',
      existing_connection_docs: 'Будь ласка, додайте останні розподільчі рахунки та принаймні один рахунок за продаж.',
      required_attachments: 'Необхідні додатки',
      property_right_document: 'Будь ласка, додайте документ, що підтверджує право на приміщення.',
      osd_reading_cycles: 'Доступні розрахункові цикли залежно від ОСР',
      wniosek_zwrot_nadplaty: 'Будь ласка, додайте заяву про повернення переплати у вигляді скану.',
      wniosek_cesja: 'Після повідомлення про зміну власника в ОСР починається процес верифікації (21 день–1,5 місяця). Оператор визначить дату, з якої рахунки будуть виставлятися новому одержувачу.\n\nБудь ласка, додайте документ, що підтверджує право на приміщення.',
      wypowiedzenie_umowy: 'Будь ласка, додайте розірвання: електронно з кваліфікованим підписом або оригінал до офісу компанії — інакше розірвання буде недійсним.',
      nota_korygujaca: 'Будь ласка, додайте коригувальну ноту у вигляді скану.',
      wniosek_zmiana_cyklu_odczytowego: 'Доступні розрахункові цикли залежно від ОСР:\n• Energa: 1м, 2м, 6м, 12м\n• Tauron: 1м, 2м, 6м, 12м\n• Stoen: 1м, 6м, 12м\n• Enea: 1м, 2м, 6м, 12м\n• PGE: 1м, 2м, 6м',
      wniosek_dodanie_ppe_when_true: 'Будь ласка, додайте акт власності та документи, необхідні ОСР.',
      wniosek_dodanie_ppe_when_false: 'Будь ласка, додайте останні розподільчі рахунки та принаймні один рахунок за продаж.',
      wniosek_dodanie_ppe_osd_enea: 'Для ENEA необхідні: технічна картка з умовами приєднання, договір приєднання.',
      wniosek_dodanie_ppe_osd_energa: 'Для ENERGA необхідна: декларація про виконання приєднання.',
      wniosek_dodanie_ppe_osd_pge: 'Для PGE необхідне: підтвердження можливості надання послуг розподілу та визначення технічних параметрів.',
      wniosek_dodanie_ppe_osd_tauron: 'Для TAURON необхідні: довідка про виконання приєднання, технічна картка, повідомлення про готовність установки до приєднання.',
      wniosek_dodanie_ppe_osd_innogy: 'Для INNOGY необхідні: технічні дані виконаного приєднання, готовність установки до приєднання, договір приєднання.',
      wniosek_dodanie_ppe_osd_stoen: 'Для STOEN необхідні: технічні дані виконаного приєднання, готовність установки до приєднання, договір приєднання.'
    },
    errors: {
      formDataInvalidSummary: 'Помилка форми',
      formDataInvalid: 'Невірний формат даних форми — оновіть сторінку та спробуйте знову'
    }
  },

  // New Issue
  newIssue: {
    title: 'Нова заявка',
    subtitle: 'Повідомте про проблему службі підтримки',
    back: 'Назад',
    customer: 'Клієнт',
    customerPlaceholder: 'Виберіть клієнта',
    category: 'Категорія',
    categoryPlaceholder: 'Виберіть категорію',
    subcategory: 'Підкатегорія',
    subcategoryPlaceholder: 'Виберіть підкатегорію',
    selectCategoryFirst: 'Спочатку виберіть категорію',
    issueTitle: 'Назва заявки',
    titlePlaceholder: 'Короткий опис проблеми...',
    description: 'Опис',
    descriptionPlaceholder: 'Детальний опис проблеми, обставин, очікувань...',
    descriptionHint: 'Надайте якомога більше деталей для прискорення вирішення.',
    submit: 'Надіслати заявку',
    cancel: 'Скасувати',
    submitting: 'Надсилання...',
    submitSuccess: 'Заявку успішно створено. Перенаправлення...',
    submitFailed: 'Не вдалося створити заявку. Спробуйте ще раз.',
    attachments: 'Вкладення',
    addMoreFiles: 'Додати ще файли',
    formFields: 'Дані форми',
    validation: {
      customerRequired: 'Виберіть клієнта',
      categoryRequired: 'Будь ласка, виберіть категорію заявки',
      subcategoryRequired: 'Будь ласка, виберіть підкатегорію заявки',
      titleRequired: 'Введіть назву заявки',
      titleMinLength: 'Назва повинна мати мінімум 5 символів',
      descriptionRequired: 'Введіть опис заявки',
      descriptionMinLength: 'Опис повинен мати мінімум 20 символів',
      dynamicFieldRequired: 'Поле "{field}" є обов\'язковим',
      numericRequired: 'Будь ласка, введіть число',
      minValue: 'Значення не може бути меншим за {min}'
    },
    help: {
      title: 'Як подати заявку?',
      step1: '1. Виберіть клієнта - якщо у вас є доступ до кількох акаунтів, виберіть до якого стосується заявка.',
      step2: '2. Будь ласка, оберіть відповідну категорію та підкатегорію звернення, щоб швидше ідентифікувати проблему та прискорити її вирішення.',
      step3: '3. Опишіть детально - надайте всю важливу інформацію: номери документів, дати, обставини.',
      footer: 'Після надсилання звернення ви отримаєте підтвердження, і наша команда займеться справою протягом 14 днів.'
    }
  },

  // Meter Reading
  meterReading: {
    title: 'Подати показник лічильника',
    submit: 'Надіслати показник'
  },

  // Navigation (additional)
  navigation: {
    newIssue: 'Подати звернення',
    meterReading: 'Подати показник лічильника'
  },

  // Customers
  customers: {
    title: 'Клієнти',
    subtitle: 'Управління прив\'язаними акаунтами клієнтів',
    customerName: 'Клієнт',
    customerNumber: 'Номер клієнта',
    nipPesel: 'ІПН/РНОКПП',
    linkedAt: 'Дата прив\'язки',
    searchPlaceholder: 'Пошук клієнта...',
    searchHint: 'Назва, номер клієнта або ІПН',
    ppeSearchPlaceholder: 'Пошук точки...',
    ppeSearchHint: 'Код PPE, адреса або тариф',
    noCustomers: 'Немає прив\'язаних акаунтів клієнтів'
  },

  // Consumption Points
  consumptionPoints: {
    title: 'Точки споживання та генерації енергії',
    subtitle: 'Управління точками споживання та генерації енергії',
    ppeCode: 'Код PPE',
    noCode: 'Без коду',
    customer: 'Клієнт',
    category: 'Категорія',
    tariff: 'Тариф',
    contract: 'Договір',
    contractActive: 'Активний',
    contractInactive: 'Неактивний',
    searchPlaceholder: 'Пошук точки...',
    searchHint: 'Код PPE, адреса, тариф або клієнт',
    allCategories: 'Всі',
    allCustomers: 'Всі клієнти',
    noConsumptionPoints: 'Немає точок споживання та генерації',
    loadFailed: 'Не вдалося завантажити точки споживання',
    invoicesEmpty: 'Немає рахунків для цієї точки',
    categories: {
      consumption: 'Споживання',
      generation: 'Генерація'
    }
  },

  // Generation Scheduling
  scheduling: {
    contractedPower: 'Договірна потужність',
    generationSource: 'Джерело генерації',
    unitKw: 'кВт',
    title: 'Графіки генерації',
    subtitle: 'Управління графіками генерації енергії для точок генерації',
    listTitle: 'Графіки генерації',
    listSubtitle: 'Управління графіками генерації енергії для точок генерації',
    detailTitle: 'Графік генерації',
    selectPoint: 'Виберіть точку генерації',
    pointPlaceholder: 'Виберіть точку...',
    selectDate: 'Виберіть дату',
    scheduleDate: 'Дата графіка',
    schedule: 'Графік',
    schedule24h: 'Графік на 24 години',
    hour: 'Година',
    valueKwh: 'Значення (кВт·год)',
    systemProposed: 'Системне (кВт·год)',
    effectiveValue: 'Результуюче (кВт·год)',
    source: 'Джерело',
    sourceSystem: 'Система',
    sourceUser: 'Користувач',
    sourceSystemUser: 'Система+Користувач',
    total: 'Всього',
    totalEdited: 'Всього редаговано',
    totalSystem: 'Всього системне',
    totalEffective: 'Всього результуюче',
    userHours: 'Години користувача',
    editedNow: 'Редаговано зараз',
    deadline: 'Термін',
    deadlinePassed: 'Термін минув',
    deadlineInfo: 'Термін подання: {time}',
    deadlineNotice: 'Термін подання графіка: {time}',
    saveSchedule: 'Зберегти',
    downloadExcel: 'Завантажити',
    uploadFromFile: 'Завантажити з файлу',
    restoreSystem: 'Відновити системні значення',
    noPoints: 'Немає точок генерації',
    loadFailed: 'Не вдалося завантажити графік',
    saveSuccess: 'Графік успішно збережено',
    saveFailed: 'Не вдалося зберегти графік',
    deadlinePassedError: 'Термін подання графіка минув',
    noChanges: 'Немає змін для збереження',
    hoursModified: '{count} годин',
    // List page
    generationPoint: 'Точка генерації',
    noPpeCode: 'Без коду PPE',
    customer: 'Клієнт',
    allCustomers: 'Всі клієнти',
    systemTotal: 'Сума системна',
    effectiveTotal: 'Сума результуюча',
    editSchedule: 'Редагувати/переглянути графік',
    refresh: 'Оновити',
    showingPoints: 'Показано {first} до {last} з {totalRecords} точок',
    // Source/status labels
    sources: {
      none: 'Немає даних',
      system: 'Система',
      partial: 'Система+Користувач',
      full: 'Користувач'
    },
    // Upload dialog
    uploadDialog: {
      title: 'Завантажити графік з файлу Excel',
      description: 'Ви можете завантажити шаблон і змінити його, або завантажити поточний графік, змінити його та імпортувати сюди.',
      downloadTemplate: 'завантажити шаблон',
      warning: 'Якщо файл містить дату або код PPE, вони повинні відповідати поточно вибраному графіку.',
      selectFile: 'Виберіть файл Excel',
      upload: 'Завантажити',
      uploadSuccess: 'Завантажено {count} погодинних значень. Натисніть "Зберегти", щоб зберегти зміни.',
      uploadFailed: 'Не вдалося прочитати файл Excel. Перевірте, чи файл у правильному форматі.',
      noData: 'У файлі не знайдено погодинних даних',
      dateMismatch: 'Дата у файлі ({fileDate}) не відповідає вибраній даті ({selectedDate})',
      ppeMismatch: 'Код PPE у файлі ({filePpe}) не відповідає поточному ({currentPpe})',
      invalidStatuses: 'Пропущено невідомі або недозволені статуси для годин: {hours}',
      invalidStatusReasons: {
        notAllowedAfterDeadline: 'не дозволено після терміну'
      }
    },
    // Status column
    status: 'Статус',
    statusOptions: {
      none: 'Немає',
      other: 'Інше',
      pseRedispatch: 'Редиспатчинг PSE',
      installationFailure: 'Аварія установки',
      powerReduction: 'Зниження потужності',
      plannedMaintenance: 'Плановий ремонт',
      plannedShutdown: 'Планове відключення'
    },
    setStatusForAll: 'Встановити статус для всіх годин',
    bulkStatusDescription: 'Вибраний статус буде застосовано до всіх 24 годин у графіку.',
    selectStatus: 'Виберіть статус',
    apply: 'Застосувати',
    // Deadline indicator
    deadlineIndicator: {
      canEdit: 'Ви можете редагувати графік до',
      cannotEdit: 'Термін редагування минув',
      statusOnly: 'Після терміну ви можете лише змінювати статус (Редиспатчинг PSE, Аварія установки)'
    },
    // Other
    modified: 'Змінено',
    lastChange: 'Остання зміна',
    back: 'Назад',
    systemApplied: 'Системні значення застосовано до всіх годин',
    templateDownloaded: 'Шаблон завантажено',
    templateDownloadFailed: 'Не вдалося завантажити шаблон',
    excelDownloaded: 'Файл Excel завантажено',
    excelDownloadFailed: 'Не вдалося завантажити файл Excel',
    editingUnavailable: 'Редагування графіка недоступне',
    uploadUnavailable: 'Завантаження графіка недоступне - термін минув',
    tolerance: {
      exceeded: 'Значення перевищує ліміт допуску ({max} кВт·год)',
      importWarning: '{count} значень перевищує ліміт допуску ({max} кВт·год/год)'
    }
  },

  // Account Matching
  accountMatching: {
    title: 'Прив\'язати акаунт клієнта',
    subtitle: 'Прив\'яжіть свій акаунт клієнта для доступу до рахунків, договорів та точок споживання',
    verification: 'Верифікація акаунту',
    modeNip: 'Верифікація через ІПН',
    modeNipDescription: 'Для компаній та клієнтів, які мають ІПН',
    modePesel: 'Верифікація через PESEL',
    modePeselDescription: 'Для приватних клієнтів без ІПН',
    nip: 'ІПН (NIP)',
    nipPlaceholder: '0000000000',
    nipHint: '10-значний ідентифікаційний номер',
    pesel: 'PESEL',
    peselPlaceholder: '00000000000',
    peselHint: '11-значний польський номер PESEL з договору',
    peselFormatError: 'Номер PESEL має складатися з 11 цифр і мати правильну контрольну суму.',
    identifierNone: '—',
    phone: 'Номер телефону',
    phonePlaceholder: '+48 000 000 000',
    phoneHint: '+48 вписаний за замовчуванням — ви можете змінити його, якщо номер з-поза Польщі. Формат: +<код країни><цифри>',
    phoneFormatError: 'Номер має починатися з „+" та коду країни (напр. +48 для Польщі).',
    customerNumber: 'Номер клієнта',
    customerNumberPlaceholder: '123456',
    customerNumberHint: 'Номер з договору або рахунку',
    submit: 'Прив\'язати акаунт',
    submitting: 'Перевірка...',
    success: 'Акаунт успішно прив\'язано!',
    failed: 'Не вдалося прив\'язати акаунт. Перевірте ваші дані.',
    notFound: 'Акаунт з наданими даними не знайдено.',
    alreadyLinked: 'Цей акаунт вже прив\'язаний до вашого профілю.',
    rateLimited: 'Забагато спроб. Спробуйте пізніше.',
    attemptsRemaining: 'Залишилось спроб: {count}',
    noAttemptsLeft: 'Ви використали ліміт спроб. Спробуйте ще раз через {minutes} хв. Введені дані мають збігатися з договором — перевірте також, чи вибрано правильний режим верифікації (ІПН чи PESEL). Докладніше в інструкції:',
    noAttemptsLeftUnknown: 'Це була ваша остання спроба — наступну буде заблоковано. Введені дані мають збігатися з договором — перевірте також, чи вибрано правильний режим верифікації (ІПН чи PESEL). Докладніше в інструкції:',
    instructions: 'Для прив\'язки акаунту надайте дані для верифікації з рахунку або договору.',
    linkedAccounts: 'Прив\'язані акаунти',
    accountsCount: '{count} акаунт | {count} акаунтів',
    noLinkedAccounts: 'У вас ще немає прив\'язаних акаунтів',
    useFormAbove: 'Використовуйте форму вище для прив\'язки акаунту клієнта',
    active: 'Активний',
    linked: 'Прив\'язано',
    detach: 'Від\'єднати',
    detachConfirm: 'Ви впевнені, що хочете від\'єднати цей акаунт?',
    detachFailed: 'Не вдалося від\'єднати акаунт.'
  },

  // Profile
  profile: {
    title: 'Профіль користувача',
    subtitle: 'Клієнт порталу',
    personalInfo: 'Інформація про акаунт',
    email: 'Електронна адреса',
    userId: 'ID користувача',
    linkedCustomers: 'Прив\'язані клієнти',
    firstName: 'Ім\'я',
    lastName: 'Прізвище',
    phone: 'Телефон',
    changePassword: 'Змінити пароль',
    currentPassword: 'Поточний пароль',
    newPassword: 'Новий пароль',
    confirmNewPassword: 'Підтвердіть новий пароль',
    saveChanges: 'Зберегти зміни',
    updateSuccess: 'Профіль успішно оновлено',
    updateFailed: 'Не вдалося оновити профіль',
    passwordChangeSuccess: 'Пароль успішно змінено',
    passwordChangeFailed: 'Не вдалося змінити пароль',
    editComingSoon: 'Функції редагування профілю будуть доступні незабаром.',
    deleteAccount: 'Видалити акаунт',
    deleteAccountTitle: 'Видалення акаунту',
    deleteAccountWarning: 'Ця операція незворотна. Усі ваші персональні дані будуть остаточно видалені, а доступ до акаунту буде заблоковано.',
    confirmDeletion: 'Підтвердити видалення',
    deleteAccountSuccess: 'Акаунт видалено.',
    deleteAccountError: 'Не вдалося видалити акаунт. Перевірте пароль і спробуйте ще раз.',
    enterPasswordToConfirm: 'Введіть поточний пароль для підтвердження',
    linkedAccountsWarning: 'Ваші зв\'язки з {count} акаунтами клієнтів будуть деактивовані.',
    accountDeletedBanner: 'Акаунт успішно видалено та анонімізовано.',
    adminCannotDelete: 'Акаунти адміністраторів не можуть бути видалені самостійно. Зверніться до служби підтримки.',
    tooManyAttempts: 'Забагато спроб. Спробуйте пізніше.'
  },

  // Operator Management
  operatorManagement: {
    title: 'Управління операторами',
    subtitle: 'Призначайте та відкликайте операторський доступ до виробничих об\'єктів',
    assign: {
      title: 'Призначити оператора',
      description: 'Надайте користувачу операторський доступ до виробничого об\'єкту.',
      userEmail: 'Email користувача',
      userEmailPlaceholder: "operator{'@'}example.com",
      customerNumber: 'Номер клієнта',
      customerNumberPlaceholder: 'напр. 12345',
      ppeCode: 'Код ТКЕ',
      ppeCodePlaceholder: 'напр. PPE-001W',
      ppeCodeHint: 'Код точки обліку, що закінчується на W (виробничий об\'єкт)',
      ppeSelectCustomerFirst: 'Спочатку оберіть клієнта',
      submit: 'Призначити оператора',
      success: 'Користувача призначено оператором.',
      failed: 'Не вдалося призначити оператора.',
      errorUserNotFound: 'Можна додавати лише зареєстрованих користувачів.',
      errorInvalidRole: 'Користувача не можна призначити оператором.',
      fullAccessConfirmHeader: 'Підтвердити призначення Full Access',
      fullAccessConfirmMessage: 'Цей користувач має роль Full Access. Йому буде надано повний доступ до цього клієнта. Бажаєте продовжити?'
    },
    operators: {
      title: 'Список операторів',
      filterPlaceholder: 'Пошук оператора, клієнта, ТКЕ...',
      operator: 'Оператор',
      customer: 'Клієнт',
      ppe: 'Об\'єкт (ТКЕ)',
      role: 'Роль',
      roleOperator: 'Оператор',
      roleFullAccess: 'Повний доступ',
      noOperators: 'Немає призначених операторів',
      loadFailed: 'Не вдалося завантажити список операторів',
      removeTooltip: 'Відкликати доступ',
      removeHeader: 'Підтвердити відкликання доступу',
      removeConfirm: 'Ви впевнені, що хочете відкликати операторський доступ для {email} до клієнта {customer}?',
      removeAccept: 'Відкликати доступ',
      removeFailed: 'Не вдалося відкликати операторський доступ.',
      showingResults: 'Показано {first} до {last} з {totalRecords} операторів'
    },
    observe: {
      title: 'Призначити спостерігача',
      description: 'Надайте користувачу доступ спостерігача до конкретної ТКЕ. Один і той самий користувач не може бути призначений до однієї ТКЕ двічі.',
      userEmail: 'Email користувача',
      userEmailPlaceholder: "observer{'@'}example.com",
      customerNumber: 'Номер клієнта',
      customerNumberPlaceholder: 'напр. 12345',
      ppeCode: 'Код ТКЕ',
      ppeCodePlaceholder: 'напр. PPE-001',
      ppeCodeHint: 'Будь-яка точка обліку або виробництва',
      ppeSelectCustomerFirst: 'Спочатку оберіть клієнта',
      submit: 'Призначити спостерігача',
      success: 'Користувача призначено спостерігачем.',
      failed: 'Не вдалося призначити спостерігача.'
    },
    observers: {
      title: 'Список спостерігачів',
      filterPlaceholder: 'Пошук спостерігача, клієнта, ТКЕ...',
      observer: 'Спостерігач',
      customer: 'Клієнт',
      ppe: 'ТКЕ',
      noObservers: 'Немає призначених спостерігачів',
      loadFailed: 'Не вдалося завантажити список спостерігачів',
      removeTooltip: 'Відкликати доступ спостерігача',
      removeHeader: 'Підтвердити відкликання доступу',
      removeConfirm: 'Ви впевнені, що хочете відкликати доступ спостерігача для {email} до ТКЕ {ppe}?',
      removeAccept: 'Відкликати доступ',
      removeFailed: 'Не вдалося відкликати доступ спостерігача.',
      showingResults: 'Показано {first} до {last} з {totalRecords} спостерігачів'
    }
  },

  // Impersonation
  impersonate: {
    startError: 'Не вдалося розпочати імперсонацію — сесію відновлено',
    banner: {
      acting_as: 'Ви дієте як {email}',
      stop: 'Припинити імперсонацію'
    },
    panel: {
      title: 'Імперсонація користувача',
      search: 'Шукати користувача (email, ім\'я)...',
      email: 'Email',
      role: 'Роль',
      customers: 'Пов\'язані клієнти',
      action: 'Імперсонувати',
      confirm_title: 'Підтвердження імперсонації',
      confirm_message: 'Ви впевнені, що хочете діяти як {email}?'
    },
    error: {
      forbidden: 'Немає дозволу на імперсонацію',
      admin_target: 'Неможливо імперсонувати адміністратора'
    }
  },

  // Deletion warning
  deletion_warning: {
    banner: {
      message: 'Ваш обліковий запис буде видалено {date} через: {reason}. Увійдіть регулярно, щоб запобігти видаленню.'
    },
    reasons: {
      expired_contract: 'закінчення терміну дії договору',
      unverified_account: 'неактивований обліковий запис'
    }
  },

  // Errors
  errors: {
    general: 'Виникла помилка',
    networkError: 'Помилка з\'єднання з сервером',
    unauthorized: 'Сесія закінчилася. Увійдіть знову.',
    forbidden: 'Доступ до цього ресурсу заборонено',
    notFound: 'Ресурс не знайдено',
    serverError: 'Помилка сервера. Спробуйте пізніше.'
  },

  // 404 Page
  notFound: {
    title: 'Сторінку не знайдено',
    message: 'Вибачте, сторінка, яку ви шукаєте, не існує.',
    backHome: 'Повернутися на головну'
  },

  // Payment
  payment: {
    success: {
      title: 'Оплату прийнято',
      message: 'Дякуємо за оплату.',
      sync_info: 'Статус рахунку оновиться протягом кількох хвилин.',
    },
    processing: {
      title: 'Платіж в обробці',
      message: 'Ми отримали ваше платіжне доручення. Рахунок буде позначено як оплачений після підтвердження банком — зазвичай протягом кількох хвилин.',
    },
    error: {
      title: 'Виникла проблема',
      message: 'Не вдалося обробити платіж. Спробуйте ще раз або зверніться до служби підтримки.',
      contact: 'Зверніться до підтримки: {email}',
      contact_with_phone: 'Зверніться до підтримки: {email}, тел. {phone}',
      invoice_already_paid: 'Рахунок вже оплачено.',
      customer_email_missing: 'Відсутня адреса електронної пошти клієнта. Зверніться до служби підтримки.',
      access_denied: 'Доступ заборонено.',
      gateway_unavailable: 'Платіжний шлюз недоступний. Спробуйте пізніше.',
      rate_limit_exceeded: 'Забагато спроб. Спробуйте через кілька хвилин.',
      invoice_unpaid: 'Рахунок залишається неоплаченим.',
    },
    neutral: {
      title: 'Статус платежу',
      message: 'Неможливо підтвердити статус платежу. Перевірте свої рахунки.',
    },
    invoice: 'Рахунок',
    back_to_invoice: 'Повернутися до рахунку',
    view_invoices: 'Переглянути рахунки',
    login: 'Увійти',
    loading: 'Перевірка статусу платежу...',
    pay_amount: 'Оплатити {amount}',
    redirecting: 'Перенаправлення до платіжного шлюзу...',
    invoice_paid: 'Рахунок оплачено',
    pay_page: {
      title: 'Оплата рахунку',
      invoice: 'Рахунок',
      amount_due: 'До оплати',
      due_date: 'Термін оплати',
      customer: 'Клієнт',
      validity_info: 'Після натискання "Оплатити" ви будете перенаправлені до платіжного шлюзу. У вас є 24 години на завершення платежу.',
      already_paid: 'Рахунок оплачено.',
      token_expired: 'Посилання закінчилось. Зверніться до служби підтримки ({email}) для отримання нового посилання.',
      token_expired_with_phone: 'Посилання закінчилось. Зверніться до служби підтримки за номером {phone} або {email} для отримання нового посилання.',
      invalid_token: 'Недійсне посилання для оплати. Зверніться до служби підтримки ({email}).',
      invalid_token_with_phone: 'Недійсне посилання для оплати. Зверніться до служби підтримки за номером {phone} або {email}.',
      missing_token: 'Недійсне посилання для оплати. Зверніться до служби підтримки ({email}).',
      missing_token_with_phone: 'Недійсне посилання для оплати. Зверніться до служби підтримки за номером {phone} або {email}.',
      invoice_not_found: 'Рахунок не знайдено.',
      gateway_error: 'Платіжний шлюз тимчасово недоступний. Спробуйте пізніше.',
      invoice_already_paid: 'Рахунок вже оплачено.',
      rate_limit_exceeded: 'Забагато спроб. Спробуйте через кілька хвилин.',
      payment_in_progress: 'Платіж обробляється. Рахунок буде позначено як оплачений після підтвердження банком.',
      connection_error: 'Сервер недоступний. Перевірте підключення до інтернету та спробуйте ще раз.',
    },
  }
}
